import { combineReducers } from 'redux';
import produce from 'immer';
import * as RequestStatusTypes from '../constants/RequestStatusTypes';
import { CLEAR_UPDATED_THEME_SETTINGS, THEME_SETTINGS_BUFFER_PUBLISHED, THEME_SETTINGS_BUFFER_SAVED, THEME_SETTINGS_FIELD_KEY_UPDATED, THEME_SETTINGS_FETCHED_HAS_BUFFERED_CHANGES, THEME_SETTINGS_UPDATED } from '../actions/ActionTypes';
import requestStatusFactory from './factories/requestStatusFactory';
const hasBufferedChanges = (state = false, action) => produce(state, draft => {
  switch (action.type) {
    case THEME_SETTINGS_FETCHED_HAS_BUFFERED_CHANGES:
      {
        if (action.requestStatus !== RequestStatusTypes.SUCCEEDED) {
          return draft;
        }
        draft = action.payload.hasChanges;
        return draft;
      }
    case THEME_SETTINGS_BUFFER_SAVED:
      {
        if (action.requestStatus !== RequestStatusTypes.SUCCEEDED) {
          return draft;
        }
        draft = true;
        return draft;
      }
    case THEME_SETTINGS_BUFFER_PUBLISHED:
      {
        if (action.requestStatus !== RequestStatusTypes.SUCCEEDED) {
          return draft;
        }
        draft = false;
        return draft;
      }
    default:
      return draft;
  }
});
const activeFieldKey = (state = null, action) => produce(state, draft => {
  switch (action.type) {
    case THEME_SETTINGS_FIELD_KEY_UPDATED:
      {
        const {
          payload: fieldKey
        } = action;
        draft = fieldKey || null;
        return draft;
      }
    default:
      return draft;
  }
});
const lastSaveWasAutoSave = (state = null, action) => produce(state, draft => {
  switch (action.type) {
    case THEME_SETTINGS_BUFFER_SAVED:
      {
        if (action.requestStatus !== RequestStatusTypes.SUCCEEDED) {
          return draft;
        }
        const {
          payload
        } = action;
        if (payload) {
          draft = payload.isAutoSave;
        }
        return draft;
      }
    default:
      return draft;
  }
});
const updatedSettings = (state = [], action) => produce(state, draft => {
  switch (action.type) {
    case THEME_SETTINGS_UPDATED:
      {
        const {
          payload
        } = action;
        if (payload) {
          draft = [...draft, payload.key];
          return draft;
        }
        return draft;
      }
    case CLEAR_UPDATED_THEME_SETTINGS:
      {
        draft = [];
        return draft;
      }
    default:
      return draft;
  }
});
export default combineReducers({
  hasBufferedChanges,
  activeFieldKey,
  publishRequestStatus: requestStatusFactory(THEME_SETTINGS_BUFFER_PUBLISHED),
  saveRequestStatus: requestStatusFactory(THEME_SETTINGS_BUFFER_SAVED),
  updatedSettings,
  lastSaveWasAutoSave
});